module.exports = __webpack_public_path__ + "mp3-7a4f3260721a327a31d8e23ff1b4652b.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/mp3.svg
// module id = 43
// module chunks = 0